import { render } from "./blog-article-edition.vue?vue&type=template&id=a76d74d2"
import script from "./blog-article-edition.vue?vue&type=script&lang=js"
export * from "./blog-article-edition.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__